/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

require('./vendor/jquery.hmc-offsite-links.js');
import "mmenu-js";

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        
        $('body').hmcOffsiteLinks();

        /**
         * mmenu
         */
        var mmenu_api = new Mmenu('#primary', {
          // options
          extensions: [ "position-front", "position-right"],
          keyboardNavigation: {
            enable: true,
            enhance: true
          },
          },
          {
            // configuration
            offCanvas: {
              clone: true,
              page: {
                selector: ".main",
              },
            },
            classNames: {
              selected: 'active'
            }
          }
        );

        $('.nav-toggle').click(function() {

          if ($(this).attr('aria-expanded') === 'false') {
            mmenu_api.open();
            $(this).attr('aria-expanded', 'true');
          } else {
            mmenu_api.openPanel($("#mm-primary").find(".mm-panel").first()[0]);

            mmenu_api.close();
            $(this).attr('aria-expanded', 'false');
          }
        });

        $('.mm-wrapper__blocker').click(function(e) {
          e.preventDefault();
          $('.nav-toggle').click();
        });

        $('.mm-menu .menu-item a[href*="#"]').click(function() {
          var parent = $(this).parent().hasClass('has-sub-menu');

          if ( parent !== true ) {
            mmenu_api.openPanel($("#mm-primary").find(".mm-panel").first()[0]);

            mmenu_api.close();
            $('.nav-toggle').attr('aria-expanded', 'false');
          }
        });


        // View Patents Button
        $('.next-section').click(function() {
          var nextSection = $(this).closest('.module').next();
          $([document.documentElement, document.body]).animate({
            scrollTop: (nextSection.offset().top - $('header').innerHeight())
        }, 200);
        });
        

        // Search Tables
        // $('.patent-group input[type="text"]').on("keyup", function() {
        //   var value = $(this).val();
        //   var tableTR = $(this).closest('.patent-group').find('.patent-table tr');
        //   tableTR.each(function(index) {
        //       if (index !== 0) {
      
        //           var $row = $(this);
      
        //           var id = $row.find("td:first").text();
      
        //           if (id.indexOf(value) >= 0 || id.toLowerCase().indexOf(value) >= 0) {
        //             $row.show();
        //           } else {
        //             $row.hide();
        //           }
        //       }
        //   });
        // });

        let searchTimeout;
        $('.module-search-tables .search-tables').on("keyup", function() {
          clearTimeout(searchTimeout);
          searchTimeout = setTimeout(() => {
              //$('.search-loading').addClass('active');
              var searchterm = $(this).val();
              console.log(searchterm);
              $.ajax({
                url: ajax_object.ajax_url, 
                type: 'POST',
                data: {
                    action: 'patent_search', 
                    searchterm: searchterm
                },
                success: function(response) {
                  var resulthtml = response.data.html;
                  var totalresults = response.data.total;
                  var resultstext = 'No Results Found';
                  $('#patentsearchcontent').html(resulthtml);
                  if (totalresults > 0) {
                    if (searchterm) {
                      if (totalresults == 1) resultstext = '1 Result Found';
                      else resultstext = totalresults + ' Results Found';
                    }
                    else {
                      resultstext = 'Search Patents';
                    }
                  }
                  $('.module-search-tables h4').text(resultstext);
                },
                error: function() {
                    console.log('error');
                }
            });

            //$('.search-loading').removeClass('active');
          }, 1000); // delay 1 seconds in between typing
        });


        /*$('.module-search-tables .search-tables').on("keyup", function() {
          clearTimeout(searchTimeout);
          $('.search-loading').addClass('active');

          searchTimeout = setTimeout(() => {

            var value = $(this).val();
            var tableTR = $('.patent-group').find('.patent-table tbody tr');
            var maxValues = tableTR.length;
            var resultCounter = 0;
            
            tableTR.each(function() {
              var thead = $(this).closest('.section-bottom').find('thead');
              var noResults = $(this).closest('.section-bottom').find('.no-results-found');
              var thisTableResults = 0;
              var $row = $(this);

              var name = $row.find("td.name").text();
              var nameLower = name.toLowerCase();

              if (name.indexOf(value) >= 0 || nameLower.indexOf(value) >= 0) {
                $row.show();
              } else {
                $row.hide();
              }
              
              resultCounter = $('.patent-group').find('.patent-table tbody tr:visible').length;
              thisTableResults = $(this).closest('.patent-table').find('tbody tr:visible').length;

              if (thisTableResults === 0) {
                noResults.addClass('active');
                thead.hide();
              } else if( noResults.hasClass('active') ) {
                noResults.removeClass('active');
                thead.show();
              }
            });

            if (resultCounter > 1 && resultCounter !== maxValues) {
              $('.module-search-tables h4').text(resultCounter + " Results Found");
            } else if (resultCounter === 1) {
              $('.module-search-tables h4').text(resultCounter + " Result Found");
            } else if (resultCounter === 0) {
              $('.module-search-tables h4').text("No Results Found");
            } else {
              $('.module-search-tables h4').text("Search Patents");
            }

            $('.patent-table').each(function() {
              if ($(this).data('trs') === 0) {
                $(this).parent().html('<h4 class="no-patent-results">No Results Found</h4>');
              }
            });

            $('.search-loading').removeClass('active');

          }, 1500); // delay 1.5 seconds in between typing
        });*/


      },
      finalize: function() {
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
